export const FIELD_NAMES = {
  COUNTRY: 'country',
  ADDRESS: 'address',
  LATITUDE: 'latitude',
  LONGITUDE: 'longitude',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
}
